<template>
  <div class="p-content-float-button">
    <button class="p-content-float-button__btn" @click="$emit('on-click')">
      <p-icon icon="list" size="lg" color="fg-fix-white" />
    </button>
  </div>
</template>

<script setup lang="ts">
defineEmits(['on-click'])
</script>
